module.exports = "/lucky-balls/video/intro_fr.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/video/intro_fr.mp4
// module id = 885
// module chunks = 0